<template>
  <div class="allAppVues">
    <el-button type="primary" @click="del()" size="medium" style="border-radius: 10px;">搜索</el-button>
  </div>
</template>

<script>
import {
  getBqList
} from '../../api/test-api/test.js';


export default {

  data () {

    return {

    }
  },
  methods: {

    //删除
    del () {
      let cs = {
      }
      getBqList(cs).then(res => {
        if (res.outmap.status == "success") {
          this.$message({
            message: "删除成功！",
            type: 'success'
          })
        } else {

        }
      })
    },



  },
  created () {
  },

}
</script>

<style scoped>
.search {
  margin-top: 1vh;
  background-color: white;
  width: 98%;
  border-radius: 10px 10px 0 0;
}

.search-top {
  padding: 1vh 2vh;
  display: flex;
  align-items: center;
}

.search-input {
  width: 60%;
  margin-left: 1vh;
}

.button-group {
  margin-left: auto;
  display: flex;
  gap: 1vh; /* 按钮之间的间距 */
}

.horizontal-line {
  width: 100%;
  height: 1px;
  background-color: #b7c9d6;
}

.search-bottom {
  padding: 1vh 1vh 0 1vh;
}

.search-button {
  background-color: white;
  color: #1677ff;
  border-radius: 10px;
  margin-left: 1vh;
}

.data {
  padding: 0 2vh;
  background-color: white;
  width: 96%;
  border-radius: 0 0 10px 10px;
}

.custom-dialog {
  border-radius: 10px !important;
}

/deep/ .el-dialog {
  border-radius: 10px;
}

/* 修改对话框标题栏的背景色 */
/deep/ .custom-dialog .el-dialog__header {
  background: linear-gradient(to right, #1478ef, #1aacfc);
  border-radius: 10px 10px 0 0;
  /* background-color: #409eff; */
}

/deep/ .custom-dialog .el-dialog__title {
  color: #ffffff; /* 确保文本颜色可见 */
}

/deep/ .custom-dialog .el-dialog__close {
  color: #ffffff; /* 确保文本颜色可见 */
}

/deep/ .custom-dialog .el-dialog__body {
  height: 18vh;
  padding: 10px 0px;
}

/deep/ .ke-edit{
  height: 22vh !important;
}
/deep/ .ke-edit .ke-edit-iframe{
  height: 22vh !important;
}

/deep/ .el-table .ds {
  background: #fff;
}

/deep/ .el-table .ss {
  background: #f2f8ff;
}
.icon {
  cursor: pointer;
  margin-right: 5px;
}

.item {
  margin-bottom: 20px;
}

.el-tree {
  display: inline-block;
  min-width: 100%;
  overflow-x: hidden;
}
/deep/ .el-table .cell {
  font-size: 14px;
}
.inputType {
  width: 15%;
  margin-left: 10px;
}
/deep/ .el-table .el-table__cell {
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/bmgl/bmxx.vue